import MarketingCampaignsView from "./MarketingCampaignsView";

export default function MarketingCampaignsPage() {
  return <MarketingCampaignsView />;
}
